import styled from 'styled-components'

export const StyledHeader = styled.div`
 font-size: 22px !important;
 font-weight: bold;
 padding-left: 25px;
 margin-bottom: 20px;
`

export const FiltersWrapper = styled.div`
display: flex;
align-items: baseline;
flex-wrap: wrap;
gap: 10px;
`
export const ModalHeaderWrapper = styled.div`
display: flex;
align-items: baseline;
gap: 10px;
 div {
  font-size: 16px !important;
 }
`